<template>
  <div>
    <div v-if="!user.grant.log">
      <div class="h-screen flex w-full bg-img">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
            <h1 class="sm:mx-0 mx-4 mb-12 text-3xl d-theme-heading-color">404 - Page introuvable!</h1>
            <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 d-theme-heading-color">La page que vous demandez est introuvable</p>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="custom__card">
        <div class="header__ mb-2">
          <h6>Filtre</h6>
        </div>
        <div class="card__body">
          <div>
            <vs-select
              class="w-full"
              label="Agent"
              icon="arrow_downward"
              v-model="model.agent"
              autocomplete
              >
              <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in agents" />
            </vs-select>
          </div>
          <div>
            <vs-input
              class="w-full"
              label="Code"
              v-model="model.code"
              >
            </vs-input>
          </div>
          <div>
            <vs-input
              class="w-full"
              label="Date début"
              type="date"
              v-model="model.date_debut"
              :danger="errors.date_debut ? true : false"
              :danger-text="errors.date_debut ? errors.date_debut[0] : ''"
              >
            </vs-input>
          </div>
          <div>
            <vs-input
              class="w-full"
              label="Date fin"
              type="date"
              :min="model.date_debut"
              v-model="model.date_fin"
              :danger="errors.date_fin ? true : false"
              :danger-text="errors.date_fin ? errors.date_fin[0] : ''"
              >
            </vs-input>
          </div>
          <div style="height: 37px; padding: 5px"
            @click="getFilter()"
            class="mt-6 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Filtrer</span>
          </div>
          <div style="height: 37px; padding: 5px"
            @click="exportData()"
            class="mt-6 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
            <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Exporter</span>
          </div>
        </div>
      </div>
      <div id="data-list-list-view" class="data-list-container">
        <vs-table ref="table" search :max-items="10" :data="data">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center data-list-btn-container">
              <div
                @click="reload()"
                class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
                <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">Actualiser</span>
              </div>
            </div>
          </div>

          <template slot="thead">
            <vs-th>Module</vs-th>
            <vs-th>Action</vs-th>
            <vs-th>Utilisateur</vs-th>
            <vs-th>Validé par</vs-th>
            <vs-th>Code</vs-th>
            <vs-th>Message</vs-th>
            <vs-th>Date</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <span class="">{{ tr.module }} </span>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.action ? tr.action : '' }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.user ? tr.user : '' }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.user_name ? tr.user_name : '' }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.code ? tr.code : '' }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ tr.message }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ formatDate(tr.created_at) }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
        <vs-pagination
          v-if="last_page && model.page"
          :total="last_page"
          v-model="model.page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { _buildQuery } from '../../helper/helper'
import moment from 'moment'
const default_model = {
  page: 1,
  agent: '',
  date_debut: '',
  date_fin: '',
  code: ''
}
export default {
  watch: {
   'model.page': function() {
     this.getData();
   }
  },
  data: () => ({
    information:{},
    last_page: 1,
    data: [],
    model:{
      page: 1,
      agent: '',
      date_debut: '',
      date_fin: '',
      code: ''
    },
    agents: [],
    errors: [],
    user: {}
  }),
  mounted(){
    if (this.user.grant.log){
      this.getData()
      this.getAgent()
    }
  },
  created(){
    this.user = JSON.parse(localStorage.getItem('user_cnhu'))
  },
  methods:{
    getFilter(){
      if (this.model.date_debut != '' && this.model.date_fin == ''){
        const error = {date_fin: ["Veuillez selectionner une date"]}
        this.errors = error
      }else if (this.model.date_debut == '' && this.model.date_fin != ''){
        const error = {date_debut: ["Veuillez selectionner une date"]}
        this.errors = error
      }else{
        this.errors = []
        this.page = 1
        this.getData()
      }
    },
    formatDate(date){
      return moment(date).format('DD-MM-YYYY H:mm')
    },
    getAgent(){
      this.$http
        .get("/users/agent")
        .then((response) => {
          this.agents = response.data;
          this.agents.unshift({
            id: '',
            name: 'Tout'
          })
        })
        .catch((error) => {
          this.$vs.loading.close();
            if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/activities" +_buildQuery(this.model))
        .then((response) => {
          this.data = response.data.data;
          this.last_page = response.data.last_page;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
          this.$vs.notify({
            title: 'Erreur',
            text: 'Votre session a expiré',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-check',
            position: 'top-right'
          })
          this.$router.push({name: "page-login"})
        }
        });
    },

    reload(){
      this.model = { ...default_model }
      this.getData()
    },

    exportData(){
      if (this.data.length > 0){
        this.$vs.loading()
        this.$http.post('/activities/export', this.model, {
          responseType: 'blob',
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = link.href = url
          link.setAttribute('download', 'logs.xlsx')
          document.body.appendChild(link)
          link.click()
          this.$vs.loading.close()
        }).catch((error) => {
          this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$vs.notify({
              title: 'Erreur',
              text: 'Votre session a expiré',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-check',
              position: 'top-right'
            })
            this.$router.push({name: "page-login"})
          }
        })
      }else{
        this.$vs.notify({
          title: 'Information',
          text: 'Aucune donnée à exporter',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-check',
          position: 'top-right'
        })
      }
    }
  }
}
</script>
.<style lang="scss">
  .custom__card{
    min-height: 126px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
    margin-bottom: 10px;
    padding: 20px;
  }
  .card__body{
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
</style>
